package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.domain.model.EventMember

class SignOutTrackUseCase(
    private val eventTrackRepository: EventTrackRepository,
) {

    suspend operator fun invoke(eventMember: EventMember) {
        eventTrackRepository.cancelMember(eventMember.id)
    }
}